import React, { useState } from 'react';
import { Row, Col, Label, Input, Button } from 'reactstrap'

const HandleSharing = ({handleShareRecord}) => {

  const [message, setMessage] = useState(null);

  return (
    <div>
      <Row className="mt-5">
        <Col xs="12" md="5">
          <Label>Type your message here</Label>
          <Input type="textarea" placeholder="" rows="5"  
            onChange={(event) => setMessage(event.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col xs="12" md="4">
          <Button onClick={(e) => handleShareRecord(message)}>Share</Button>
        </Col>
      </Row>
    </div>
  )
}

export default HandleSharing;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/HandleSharing.js